import { ContaBancariaForm } from 'app/main/pessoa/ContaBancaria';
import { useFormikContext } from 'formik';
import React from 'react';

const TabContaBancaria = (props) => {
  const { visualizar } = props;
  const { values, handleChange, errors, touched } = useFormikContext();
  const { conta = {} } = values.pessoa;
  const { contaBancaria = {} } = conta;
  return (
    <ContaBancariaForm
      readOnly={visualizar}
      contaDescricao={conta.descricao}
      contaBancaria={contaBancaria}
      handleChange={handleChange}
      errors={errors}
      touched={touched}
    />
  );
};
export default TabContaBancaria;
